import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { concat, Observable, of, Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import { CoreMenuService } from '@core/components/core-menu/core-menu.service';
import { NftService } from 'app/sections/nft/services/nft.service';
import { Router } from '@angular/router';
import { GuapMakerCollection } from 'app/interfaces/guap-maker';

@Component({
  selector: '[app-nft-search]',
  templateUrl: './nft-search.component.html',
  styleUrls: ['./nft-search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class NftSearchComponent implements OnInit, OnDestroy {

  public collection$: Observable<Array<GuapMakerCollection>>;
  public collectionInput$ = new Subject<string>();
  private _unsubscribeAll: Subject<any>;
  public selectedCollection: GuapMakerCollection = null;
  public collectionLoading: boolean = false;

  constructor(
    private nftService: NftService, 
    private _coreMenuService: CoreMenuService,
    private router: Router) { 
    this._unsubscribeAll = new Subject();
  }

  ngOnInit(): void {
    this.nftService.selectedCollectionInfo.pipe(takeUntil(this._unsubscribeAll)).subscribe((collection: GuapMakerCollection)=>{
      if(collection){
        this.collection$ = of([collection]);
        this.selectedCollection = collection;
        const menu = this._coreMenuService.getMenu('nft');
        this.enableMenu(menu);
        this._coreMenuService.setCurrentMenu('nft')  
      } else {
        this.selectedCollection = null;
        this.collectionLoading = false;
        this.collection$ = of([]);
      }
    });

    this.collectionInput$.pipe(takeUntil(this._unsubscribeAll)).subscribe((value) => {
      this.getCollections(value).subscribe();
    });
  }

  trackByFn(item: any) {
    return item.name;
  }

  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  enableMenu(menu){
    menu.forEach(element => {
      if(element.hasOwnProperty('disabled')){
        element.disabled = false;
      }
      if(element.hasOwnProperty('children')){
        this.enableMenu(element.children)
      }
    });

    return menu;
  }

  collectionChange(value){
    if(value){
      this.nftService.selectedCollectionInfo.next(value);
      this.router.navigate(['nft/collection', value.contractAddress, 'summary']);  
    }
  }

  getCollections(term: string = null): Observable<any> {
    if(term && term.length >= 3){
      this.collectionLoading = true;
      term = term.toLowerCase();
      return this.nftService.searchProject(term).pipe(
        map((resp: any) =>{
          this.collectionLoading = false;
          this.collection$ = concat(of(resp));
          return resp;
        })
      )
    } else {
      return of([]);
    }
  }

}
